export const nfseCertificateErrorMappings = {
    NFSE_CERTIFICATE_PASSWORD_INVALID: {
        code: 'NFSE_CERTIFICATE_PASSWORD_INVALID',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Senha do certificado inválida. Verifique a senha informada.',
            },
            {
                language: 'en-US',
                message: 'Invalid certificate password. Please check the password provided.',
            },
            {
                language: 'es-ES',
                message: 'Contraseña del certificado inválida. Verifique la contraseña proporcionada.',
            },
            {
                language: 'pt-BR',
                message: 'Senha do certificado inválida. Verifique a senha informada.',
            },
        ],
        technicalMessage: 'Senha do certificado inválida',
        severity: 'error',
        critical: false,
    },
    NFSE_CERTIFICATE_MISSING_PASSWORD: {
        code: 'NFSE_CERTIFICATE_MISSING_PASSWORD',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Informe a senha do certificado digital.',
            },
            {
                language: 'en-US',
                message: 'Enter the digital certificate password.',
            },
            {
                language: 'es-ES',
                message: 'Informe la contraseña del certificado digital.',
            },
            {
                language: 'pt-BR',
                message: 'Informe a senha do certificado digital.',
            },
        ],
        technicalMessage: 'Missing NFSe certificate password',
        severity: 'error',
        critical: false,
    },
    NFSE_CERTIFICATE_INVALID_PASSWORD: {
        code: 'NFSE_CERTIFICATE_INVALID_PASSWORD',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Senha do certificado inválida. Verifique a senha informada.',
            },
            {
                language: 'en-US',
                message: 'Invalid certificate password. Please check the provided password.',
            },
            {
                language: 'es-ES',
                message: 'Contraseña del certificado inválida. Verifique la contraseña informada.',
            },
            {
                language: 'pt-BR',
                message: 'Senha do certificado inválida. Verifique a senha informada.',
            },
        ],
        technicalMessage: 'Invalid NFSe certificate password',
        severity: 'error',
        critical: false,
    },
    NFSE_CERTIFICATE_CONFIG_ERROR: {
        code: 'NFSE_CERTIFICATE_CONFIG_ERROR',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Falha ao configurar o certificado. Tente novamente.',
            },
            {
                language: 'en-US',
                message: 'Failed to configure certificate. Please try again.',
            },
            {
                language: 'es-ES',
                message: 'Error al configurar el certificado. Intente nuevamente.',
            },
            {
                language: 'pt-BR',
                message: 'Falha ao configurar o certificado. Tente novamente.',
            },
        ],
        technicalMessage: 'Falha ao configurar o certificado',
        severity: 'error',
        critical: false,
    },
    NFSE_CERTIFICATE_EXPIRED: {
        code: 'NFSE_CERTIFICATE_EXPIRED',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Certificado vencido. É necessário renovar o certificado.',
            },
            {
                language: 'en-US',
                message: 'Certificate expired. The certificate needs to be renewed.',
            },
            {
                language: 'es-ES',
                message: 'Certificado vencido. Es necesario renovar el certificado.',
            },
            {
                language: 'pt-BR',
                message: 'Certificado vencido. É necessário renovar o certificado.',
            },
        ],
        technicalMessage: 'Certificado vencido',
        severity: 'error',
        critical: false,
    },
    NFSE_CERTIFICATE_CNPJ_NOT_FOUND: {
        code: 'NFSE_CERTIFICATE_CNPJ_NOT_FOUND',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Não foi possível identificar o CNPJ no certificado. Verifique o arquivo enviado.',
            },
            {
                language: 'en-US',
                message: 'Could not identify the CNPJ in the certificate. Please check the uploaded file.',
            },
            {
                language: 'es-ES',
                message: 'No fue posible identificar el CNPJ en el certificado. Verifique el archivo cargado.',
            },
            {
                language: 'pt-BR',
                message: 'Não foi possível identificar o CNPJ no certificado. Verifique o arquivo enviado.',
            },
        ],
        technicalMessage: 'NFSe certificate CNPJ not found',
        severity: 'error',
        critical: false,
    },
    NFSE_CERTIFICATE_CNPJ_MISMATCH: {
        code: 'NFSE_CERTIFICATE_CNPJ_MISMATCH',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O CNPJ do certificado não corresponde ao CNPJ da empresa informada.',
            },
            {
                language: 'en-US',
                message: 'The certificate CNPJ does not match the provided company CNPJ.',
            },
            {
                language: 'es-ES',
                message: 'El CNPJ del certificado no corresponde al CNPJ de la empresa informada.',
            },
            {
                language: 'pt-BR',
                message: 'O CNPJ do certificado não corresponde ao CNPJ da empresa informada.',
            },
        ],
        technicalMessage: 'NFSe certificate CNPJ mismatch',
        severity: 'error',
        critical: false,
    },
    NFSE_CERTIFICATE_INVALID_FILE: {
        code: 'NFSE_CERTIFICATE_INVALID_FILE',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Arquivo de certificado inválido. Envie um certificado PFX/P12 válido.',
            },
            {
                language: 'en-US',
                message: 'Invalid certificate file. Upload a valid PFX/P12 certificate.',
            },
            {
                language: 'es-ES',
                message: 'Archivo de certificado inválido. Envíe un certificado PFX/P12 válido.',
            },
            {
                language: 'pt-BR',
                message: 'Arquivo de certificado inválido. Envie um certificado PFX/P12 válido.',
            },
        ],
        technicalMessage: 'Invalid NFSe certificate file',
        severity: 'error',
        critical: false,
    },
};
